export const translations = {
  en: {
    title: "Mobile2 Patch Notes",
    login: "Login",
    logout: "Logout",
    Home: "Home", 
    FAQ: "FAQ",
    mobile2patchnotes: "Mobile2 Patch Notes",
    newupdatewaspublished: "New Update Was Published",
    failedtoloadpatch: "Failed To Load Patch",
    addnewpatch: "Add New Patch",
    details: "Details",
    patchsummary: "Patch Summary",
    patchnotfound: "Patch Not Found",
  },
  tr: {
    title: "Mobile2 Yama Notları",
    login: "Giriş Yap",
    logout: "Çıkış Yap",
    Home: "Anasayfa", 
    FAQ: "SSS",
    mobile2patchnotes: "Mobile2 Yama Notları",
    newupdatewaspublished: "Yeni Sürüm Yayınlandı",
    failedtoloadpatch: "Yama Yüklenirken Bir Sorun Oluştu",
    addnewpatch: "Yeni Yama Ekle",
    details: "Detaylar",
    patchsummary: "Yama Özeti",
    patchnotfound: "Yama Bulunamadı",
  },
};